import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=07cd7b0b&"
import script from "./embed.vue?vue&type=script&lang=js&"
export * from "./embed.vue?vue&type=script&lang=js&"
import style0 from "./embed.vue?vue&type=style&index=0&id=07cd7b0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsOrganismMenuBarEmbedProject: require('/app/components/organisms/OrganismMenuBarEmbedProject.vue').default})
